import {InjectionToken} from '@angular/core';
import {DeliveryNoteConfig} from './types/delivery-note-config';

export const SOFTLINE_FEATURE_DELIVERY_NOTE = 'deliveryNote';
export const SOFTLINE_FEATURE_RETURN_NOTE = 'retourNote';

export const SOFTLINE_CONFIG_LIEFERSCHEIN = new InjectionToken<DeliveryNoteConfig>('SOFTLINE_CONFIG_LIEFERSCHEIN');
export const SOFTLINE_PERMISSION_LIEFERSCHEIN = 'LIEFERSCHEIN';
